import { defineStore } from 'pinia'

interface GodPayloadInterface {
  email: string;
  password: string;
}

export interface GodState {
  id: string;
  email: string;
  displayName: string;
  permissions: string[];
}

// O cookie de sessão é httpOnly (gravado/limpo pelo servidor) — a store não lê nem
// escreve cookie: a sessão hidrata só por GET /api/god/me.
export const useAuthStore = defineStore('auth', {
  state: () => ({
    god: null as GodState | null,
    loading: false,
    fetched: false,
    fetchPromise: null as Promise<void> | null,
  }),
  actions: {
    async authenticateGod({ email, password }: GodPayloadInterface) {
      this.loading = true
      try {
        await $fetch('/api/auth/signin', {
          method: 'POST',
          body: { email, password },
        })
        await this.fetchMe(true)
      } catch (error) {
        console.error('Falha na autenticação:', error)
        this.god = null
      } finally {
        this.loading = false
      }
    },
    // Idempotente e single-flight: o middleware chama a cada navegação sem sessão;
    // 401 = sem sessão (é assim que se descobre, já que o cookie é invisível ao JS)
    async fetchMe(force = false): Promise<void> {
      if (this.fetched && !force) return
      if (this.fetchPromise && !force) return this.fetchPromise

      const promise = (async () => {
        try {
          const me: any = await $fetch('/api/god/me')
          this.god = {
            id: me?.id,
            email: me?.email,
            displayName: me?.displayName,
            permissions: me?.permissions || [],
          }
        } catch (error: any) {
          const status = error?.statusCode || error?.status
          if (status !== 401) {
            console.error('Falha ao carregar a sessão:', error)
          }
          this.god = null
        } finally {
          this.fetched = true
          this.fetchPromise = null
        }
      })()

      this.fetchPromise = promise
      return promise
    },
    async logGodOut() {
      try {
        await $fetch('/api/auth/signout', { method: 'POST' })
      } catch (error) {
        console.error('Falha ao encerrar a sessão:', error)
      }
      this.god = null
      this.fetched = false
    },
  },
})
